<script>
  import Docs from './Docs.svelte'
  import Button from './Button.svelte'
  import Figure from './Figure.svelte'
  
  export let labels
  export let docs
  export let config

  console.log(config)

</script>

<!-- Docs -->
{#if docs}
  <Docs />
{:else}
  <!-- Hero -->
  <section 
    class="{labels ? 'show-labels' : ''} label | text-gray-700 body-font py-6">

    <!-- Container -->
    <div 
      data-field-label="Hero"
      class="label | container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">

      <!-- Content -->
      <div 
        class="label offset | lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">

        <!-- Preheader -->
        {#if config.preheader.length > 0}
          <p
            data-field-label="Preheader"
            class="label | title-font mb-4 font-medium text-gray-900 uppercase">
            {config.preheader}
          </p>
        {/if}
        <!-- Title -->
        <h1 
          data-field-label="Title"
          class="label | title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
          {config.title}
        </h1>

        <!-- Subtitle -->
        {#if config.subtitle.length > 0}
        <h2 
          data-field-label="Subtitle"
          class="label | title-font sm:text-2xl text-1xl mb-4 text-gray-900">
          {config.subtitle}
        </h2>
        {/if}

        <!-- Body -->
        {#if config.body.length > 0}
          <p
            data-field-label="Body" 
            class="label | mb-8 leading-relaxed">
            {config.body}
          </p>
        {/if}

        <!-- Actions -->
        {#if config.actions.length > 0}
          <div 
            data-field-label="Actions"
            class="label offset | flex justify-center mt-6">
            {#each config.actions as action}
              <Button {...action} />
            {/each}
          </div>
        {/if}
      </div>

      <Figure 
        url="{config.figure.url}"
        alt="{config.figure.alt}"
        attrURL="{config.figure.attribution.url}"
        attrCTA="{config.figure.attribution.cta}"
      />
    </div>
  </section>  

{/if}
